module.exports = __webpack_public_path__ + "h5/img/extinct-start.26a333aa.png";